import { lazy } from "react"
import { Navigate } from "react-router-dom"
import { PRODUCTION_PERMISSIONS } from "src/modules/production/constants/permissions"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"

const BomList = lazy(() => import("src/modules/production/bom/pages/BomList"))
const BomDetail = lazy(() => import("src/modules/production/bom/pages/BomDetail"))
const CreateBomVersion = lazy(() => import("src/modules/production/bom/pages/CreateBomVersion"))
const BomVersionDetail = lazy(() => import("src/modules/production/bom/pages/BomVersionDetail"))
const ProductionPlanList = lazy(() => import("src/modules/production/production-plan/pages/ProductionPlanList/index"))
const ProductionPlanDetail = lazy(
  () => import("src/modules/production/production-plan/pages/ProductionPlanDetail/index")
)
const ProductionOrderList = lazy(
  () => import("src/modules/production/production-order/pages/ProductionOrderList/index")
)
const ProductionOrderDetail = lazy(
  () => import("src/modules/production/production-order/pages/ProductionOrderDetail/index")
)

const productionRoutes = {
  path: "production",
  element: <Root />,
  children: [
    { index: true, element: <Navigate to="/app/production/bom" replace /> },
    {
      path: "plans",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.PLAN_READ}>
              <ProductionPlanList />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.PLAN_READ}>
              <ProductionPlanDetail />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "orders",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.ORDER_READ}>
              <ProductionOrderList />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.ORDER_READ}>
              <ProductionOrderDetail />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "bom",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.BOM_READ}>
              <BomList />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.BOM_READ}>
              <BomDetail />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id/versions/new",
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.BOM_VERSION_CREATE}>
              <CreateBomVersion />
            </PermissionRoute>
          )
        },
        {
          path: "version/:versionId",
          element: (
            <PermissionRoute permission={PRODUCTION_PERMISSIONS.BOM_VERSION_READ}>
              <BomVersionDetail />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}

export default productionRoutes
